export var timeLineId = 101;
export var enlargeRowId = 102;
export var tooltipId = 103;
export var symbolWarningId = 801;
export var triangleLeftId = 991;
export var triangleRightId = 992;
export var memoCornerId = 998;